import { FILES_CONSTANTS } from 'shared/helpers/constants/filesConstants';
import { LOTS } from 'shared/helpers/constants/lots/lotsConstants';
import { VALIDATE_UTF_8, PDF_REGEX } from 'shared/helpers/validations/regularExpressions';

const validate = (values, { uploadCountSheetFile: { countSheet } }) => {
  const errors = {};

  if (countSheet) {
    if (countSheet.size > FILES_CONSTANTS.MAX_FILE_SIZE) {
      errors.countSheet = LOTS.ERRORS.INVALID_SIZE;
    }

    if (!PDF_REGEX.test(countSheet.name)) {
      errors.countSheet = LOTS.ERRORS.INVALID_FILE_FORMAT;
    }

    if (!VALIDATE_UTF_8().test(countSheet.name)) {
      errors.countSheet = LOTS.ERRORS.INVALID_FILE_NAME;
    }
  }

  return errors;
};

export { validate };
